
import { Component, Vue } from 'vue-property-decorator'
import AppBox from '@/components/AppBox.vue'
import AppButtonOutline from '@/components/AppButtonOutline.vue'
import AppCheckbox from '@/components/AppCheckbox.vue'
import AppInput from '@/components/AppInput.vue'
import { DebouncedFunc, debounce, cloneDeep } from 'lodash'
import { ChildComponentMixin } from '@/mixins'

@Component({
    components: {
        AppBox,
        AppButtonOutline,
        AppCheckbox,
        AppInput,
    },
})

export default class IntegrationsSearch extends ChildComponentMixin {
    public name: string = ''
    public partner: string = ''
    public category: string = ''
    public status: string = ''
    public onlySpotlight: boolean = false

    private debounced: DebouncedFunc<(() => {})> | null = null

    get categoriesOptions(): InputSelectOptionEntity[] {
        const categories = cloneDeep(this.$store.state.integration.modulecategories)

        const mappedCategories = categories.map((category: ModulecategoryEntity) => {
            return { value: category.id.toString(), text: category.name }
        })

        const emptyCategory = [{ value: '', text: '' }]
        const allCategories = emptyCategory.concat(mappedCategories)

        return allCategories
    }

    get statusOptions(): InputSelectOptionEntity[] {
        return [
            { value: '', text: '' },
            { value: 'ACTIVE', text: 'Ativo' },
            { value: 'INACTIVE', text: 'Inativo' },
        ]
    }

    get checkboxIcons() {
        return {
            check: ['fas', 'star'],
            uncheck: ['far', 'star'],
        }
    }

    public async mounted() {
        const name = this.$route.query.name
        const partner = this.$route.query.partner
        const category = this.$route.query.category
        const status = this.$route.query.status
        const onlySpotlight = this.$route.query.onlySpotlight

        if (name !== null && typeof name === 'string') {
            this.name = name
        }

        if (partner !== null && typeof partner === 'string') {
            this.partner = partner
        }

        if (category !== null && typeof category === 'string') {
            this.category = category
        }

        if (status !== null && typeof status === 'string') {
            this.status = status
        }

        if (onlySpotlight !== null && typeof onlySpotlight === 'string') {
            this.onlySpotlight = onlySpotlight !== '0'
        }

        this.search()
    }

    public search() {
        this.$store.dispatch('integration/filterIntegrationModules', {
            name: this.name,
            partner: this.partner,
            category: this.category,
            status: this.status,
            onlySpotlight: this.onlySpotlight,
        })
    }

    private onTypeSearch() {
        if (this.debounced != null) {
            this.debounced.cancel()
        }
        this.debounced = debounce(async () => {
            this.search()
        }, 1000)
        this.debounced()
    }
}
